import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';

import AchievementsBar         from '@common/influencer/parts/contents/achievements/achievements-bar';
import AchievementsAvg         from '@common/influencer/parts/contents/achievements/achievements-avg';
import AchievementProjectScore from '@common/influencer/parts/contents/achievements/achievements-project-score';
// -------------------------------------------------------

class InfluencerAchievements extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      mode: 'reach',
      project_mode : null,
    };
  }
  // -------------------------------------------------------
  
  changeEvent(column, value) {
    if( column == 'mode' ) this.setState({ mode: value });
    if( column == 'project_mode' ) this.setState({ project_mode: value });
  }
  // -------------------------------------------------------
  
  changeProjectMode(value) {
    if( value == this.state.project_mode ){
      this.setState({ project_mode: null });
    } else {
      this.setState({ project_mode: value });
    }
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    // プロジェクトごとの処理
    let projects = data.achievements;
    if( projects.length == 0 ) return <div className="influencer-achievements"><p className="influencer-achievements-none">実績がありません</p></div>
    
    return (
      <div className="influencer-achievements">
        
        <AchievementsBar projects={projects} change_ev={this.changeProjectMode.bind(this)} />
        <AchievementsAvg projects={projects} mode={this.state.mode} />
        <AchievementProjectScore projects={projects} mode={this.state.mode} project_mode={this.state.project_mode} change_ev={this.changeEvent.bind(this)} />
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerAchievements;